'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ContentControlWrapper = (_ref) => {
  let {
    children,
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "className"]);

  return /*#__PURE__*/_jsx("div", Object.assign({
    className: classNames('content-control-wrapper', className)
  }, rest, {
    children: children
  }));
};

ContentControlWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export default ContentControlWrapper;